import axiosInstance from './axiosInstance';

let cachedUser;
let inFlightUser;

export const getCurrentUser = () => {
  if (cachedUser) return Promise.resolve(cachedUser);
  if (!inFlightUser) {
    inFlightUser = axiosInstance('/user/get_user_info', 'get')
      .then((response) => {
        if (!response || response.status >= 400) throw new Error('Unable to load user');
        cachedUser = response?.data?.user || null;
        return cachedUser;
      })
      .finally(() => {
        inFlightUser = null;
      });
  }
  return inFlightUser;
};

export const clearCurrentUser = () => {
  cachedUser = undefined;
  inFlightUser = undefined;
};

export const setCurrentUser = (user) => {
  cachedUser = user || null;
  inFlightUser = undefined;
  return cachedUser;
};

export const updateCurrentUserTheme = async (theme) => {
  const response = await axiosInstance('/user/theme', 'put', { theme });
  if (!response || response.status >= 400) throw new Error('Unable to update theme');
  if (cachedUser) cachedUser = { ...cachedUser, theme };
  return theme;
};
